import dayjs from 'dayjs'
import { sleep } from '@enuygun/frontend-components'

import { savePreviousCategoryBeforeSubmit } from 'utils/searchForm'

import { logHomepageSearchFormSubmit, resolveHomepageSearchRef } from './searchFormSubmitTracking'
import type { SearchFormSubmitOptions } from './submitOptions'

export const busHandleSubmit = async (form, options: SearchFormSubmitOptions = {}) => {
  const { index = null, delay = 0, url = 'https://www.enuygun.com', variant, productCategory } = options
  const refValue = resolveHomepageSearchRef(variant)

  if (index !== null) savePreviousCategoryBeforeSubmit(String(index))
  logHomepageSearchFormSubmit({ variant, productCategory: productCategory || 'otobus-bileti' })

  const departureDate = dayjs(form.departureDate).format('DD.MM.YYYY')
  const originLocation = form.originLocation.slug
  const destinationLocation = form.destinationLocation.slug

  const params = `${originLocation}-${destinationLocation}/?gidis=${departureDate}&ref=${refValue}`

  await sleep(delay)

  globalThis.location.href = `${url}/otobus-bileti/arama/${params}`
}
